/** Bands & venues: the roster lists and the band / venue sheets. Counts and years are the server's. */
import { getJson, qs, send } from "./request";

export type Sort = "count" | "name";
export interface BandRow {
  id: number;
  name: string;
  times_seen: number;
  first: string | null;
  last: string | null;
  years: number[];
  aliases: string[];
}
export interface VenueRow {
  id: number;
  name: string;
  location: string | null;
  closed: boolean;
  show_count: number;
  first: string | null;
  last: string | null;
  years: number[];
}
export interface HistoryRow {
  id: number;
  date: string;
  venue?: string;
  event: string | null;
  bill: string | null;
  number: number;
  played_as?: string | null;
}
export interface BandDetail {
  id: number;
  name: string;
  setlistfm_mbid: string | null;
  aliases: { id: number; name: string; shows: number }[];
  times_seen: number;
  years: number[];
  shows: HistoryRow[];
}
export interface VenueDetail {
  id: number;
  name: string;
  location: string | null;
  closed: boolean;
  place_id: string | null;
  years: number[];
  shows: HistoryRow[];
}

export const fetchBands = async (q: string, sort: Sort) =>
  (await getJson<{ bands: BandRow[] }>(`/api/bands${qs({ q: q.trim(), sort: sort === "count" ? null : sort })}`, "Could not load bands")).bands;
export const fetchVenues = async (q: string, sort: Sort) =>
  (await getJson<{ venues: VenueRow[] }>(`/api/venues${qs({ q: q.trim(), sort: sort === "count" ? null : sort })}`, "Could not load venues")).venues;
export const fetchBand = (id: number) => getJson<BandDetail>(`/api/bands/${id}`, "Could not load the band");
export const fetchVenue = (id: number) => getJson<VenueDetail>(`/api/venues/${id}`, "Could not load the venue");

export const saveBand = (id: number, name: string, mbid: string) =>
  send(`/api/bands/${id}`, "PUT", { name: name.trim(), setlistfm_mbid: mbid.trim() || null }, "Could not save the band");
export const saveVenue = (id: number, name: string, location: string, closed: boolean) =>
  send(`/api/venues/${id}`, "PUT", { name: name.trim(), location: location.trim() || null, closed }, "Could not save the venue");
export const addAlias = (id: number, aliasId: number) => send(`/api/bands/${id}/aliases`, "POST", { alias_id: aliasId }, "Could not group them");
export const removeAlias = (id: number, aliasId: number) => send(`/api/bands/${id}/aliases/${aliasId}`, "DELETE", undefined, "Could not ungroup it");

/** Every year from the earliest in the rows to this one: the timeline's columns. */
export function yearRange(rows: { years: number[] }[], thisYear: number): number[] {
  const first = Math.min(thisYear, ...rows.flatMap((r) => r.years));
  return Array.from({ length: thisYear - first + 1 }, (_, i) => first + i);
}

export const strip = (years: number[], range: number[]) => {
  const on = new Set(years);
  return range.map((y) => on.has(y));
};

export function mapsLink(name: string, location: string | null, placeId: string | null): string {
  const query = encodeURIComponent([name, location].filter(Boolean).join(", "));
  return `https://www.google.com/maps/search/?api=1&query=${query}${placeId ? `&query_place_id=${encodeURIComponent(placeId)}` : ""}`;
}
